import {Injectable, Provider} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {ILanguage, ILanguageCode} from './language';
import {environment} from '@root/src/environments/environment';


export function provideAppLanguageManager(): Provider[] {
  return [
    AppLanguageManager
  ]
}

@Injectable()
export class AppLanguageManager {
  private _currentLanguage: ILanguage | undefined;
  get currentLanguage(): ILanguage | undefined { return this._currentLanguage; }

  private _afterInitialized = new ReplaySubject<void>();


  private _onChange = new Subject<ILanguage>();
  get onChange(): Observable<ILanguage> {
    return this._onChange.asObservable();
  }

  public readonly availableLanguages: ILanguage[] =environment.langs as any;


  constructor() {

  }

  initialize() {
    this._currentLanguage = this.getLanguageFormLocalStorage() || this.getConfigDefaultLanguage() || this.getDefaultLanguage();
    this._afterInitialized.next();
    //this._afterInitialized.complete();
  }

  changeLanguage(code: ILanguageCode){
    if(code === this._currentLanguage?.value) return;

    const language = this.findLanguage(code);
    if(!language){
      throw new Error(`The language with code='${code}' not available.`)
    }
    this._currentLanguage = language;
    this.saveLanguage(language!);
    this._onChange.next(language!);
  }

  getConfigDefaultLanguage(): ILanguage | undefined {
    return this.findLanguage(environment.defaultLang as ILanguageCode);
  }

  getDefaultLanguage(): ILanguage {
    return this.availableLanguages[0];
  }

  getLanguageFormLocalStorage(): ILanguage | null {
    const value = localStorage.getItem('lang');
    if(!value) return null;

    const language = this.findLanguage(value! as ILanguageCode);
    if(!language) return null;
    return language;
  }

  saveLanguage(language: ILanguage){
    localStorage.setItem('lang', language.value);
  }

  findLanguage(code: ILanguageCode): ILanguage | undefined {
    return this.availableLanguages.find(l => l.value === code);
  }
}
